module.exports = __webpack_public_path__ + "static/img/danchuBanner.4a41216a.png";